<template>
  <div class="page_bg">
    <!-- 顶部导航栏 -->
    <div class="back_box">
      <div class="back_left">
        <div class="back_btn" @click="backPage">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="page_title">
          <span class="class_name">{{ className }}</span>
        </div>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="main_box">
      <!-- 左侧功能入口 -->
      <div class="left">
        <div class="exam_item" :class="{ invisible: !item.text }" v-for="(item, index) in examArr" :key="index"
          @click="jumpPage(index)" v-throttle :style="{ animationDelay: (index % 9) * 0.05 + 's' }">
          <img :src="item.pic" alt="" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>

      <!-- 右侧考试成绩 -->
      <div class="right">
        <div class="right_title">
          <i class="el-icon-data-analysis title_icon"></i>
          考试成绩
        </div>
        <div class="btn_box">
          <div class="btn_item" v-for="(item, index) in examBtnArr" :key="index" @click="lookSubject(index)">
            <img :src="item.pic" alt="" />
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="page_end_fixed">
      <endBox></endBox>
    </div>

    <cuotizhuankao-pop v-if="isShowCuotizhuankaoPop" @close="isShowCuotizhuankaoPop=false"
      @start="handleCuoTiZhuanKao"></cuotizhuankao-pop>
  </div>
</template>

<script>
import { _getDateList,_getDateListStudy } from "../api/bigScreen.js"
import * as global from '@/mixins/global.js';
import * as examinationApi from '@/api/examination.js';
import * as wrongCheckApi from '@/api/wrongCheck.js';
import CuotizhuankaoPop from '@/components/cuotizhuankao-pop.vue';


export default {
  components: {
    CuotizhuankaoPop
  },
  created() {
    this.className = this.$route.params.className || window.localStorage.getItem("className") || ""
  },

  mounted() { },
  data() {
    return {
      className: "",
      examBtnArr: [
        {
          text: "模考成绩",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/indexBtn1.png",
        },
        {
          text: "统考成绩",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/indexBtn2.png",
        },
      ],
      examArr: [
        {
          text: "单科练习",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class1.png",
        },
        {
          text: "综合模拟",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class2.png",
        },
        {
          text: "统一考试",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class3.png",
        },
        {
          text: "个人专考",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class6.png",
        },
        {
          text: "错题查看",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class7.png",
        },
        {
          text: "错题专考",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class8.png",
        },
        {
          text: "学习报告",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class4.png",
        },
        {
          text: "考试报告",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class5.png",
        },
        {
          text: "分析报告",
          pic: "https://resources.sxsaas.com/static/jigou-saas-app/class9.png",
        },
        {
          text: null,
          pic: null,
        },
      ],
      isShowCuotizhuankaoPop:false,
    };
  },
  methods: {
    lookSubject(index) {
      console.log(index);
      switch (parseInt(index)) {
        case 0:
          window.localStorage.setItem("lookIndex", 0)
          this.$router.push({ name: 'LookList' });
          break;
        case 1:
          window.localStorage.setItem("lookIndex", 1)
          this.$router.push({ name: 'LookList' });
          break;
        default:
          break;
      }
    },
    backPage() {
      this.$router.push({ name: 'ClassName' })
    },
    setDate(data) {
      let tempArr = []
      for (let i = 0; i < data.length; i++) {
        tempArr[i] = data[i].days
      }
      return tempArr
    },
    async jumpPage(index) {
      switch (parseInt(index)) {
        case 0:
          console.log("单科练习");
          this.$router.push({ name: "DKLXList" });
          break;
        case 1:
          console.log("综合模拟");
          this.$router.push({ name: "TYKSList", query: { examType: global.ExamType.MoKao } });
          break;
        case 2:
          console.log("统一考试");
          this.$router.push({ name: "TYKSList", query: { examType: global.ExamType.TongKao } });
          break;
        case 3:
          console.log("个人专考");
          this.handleZhuanKao();
          break;
        case 4:
          console.log("错题查看");
          this.handleCuoTiChaKan();
          break;
        case 5:
          console.log("错题专考");
          this.isShowCuotizhuankaoPop = true;
          break;
        case 6:
          let params1 = {
            pro_id: window.localStorage.getItem("proID"),
            isShowErr: true,
          }
          // 获取日期列表
          let res1 = await _getDateListStudy(params1)

          let dateArr1 = this.setDate(res1.data[0])//格式化日期 获取数组
          if (dateArr1.length <= 0) {
            return this.$message({ message: "暂无学习记录", type: "error" })
          }

          console.log("学习报告");
          window.localStorage.setItem("bigScreenNavIndex", 0)
          let routeData1 = this.$router.resolve({
            name: "BigScreenStudy",
          });
          window.open(routeData1.href, '_blank');
          break;
        case 7:
          let params2 = {
            pro_id: window.localStorage.getItem("proID"),
            isShowErr: true,
          }

          // 获取日期列表
          let res2 = await _getDateList(params2)
          let dateArr2 = this.setDate(res2.data[0])//格式化日期 获取数组
          if (dateArr2.length <= 0) {
            return this.$message({ message: "暂无考试记录", type: "error" })
          }

          console.log("考试报告");
          window.localStorage.setItem("bigScreenNavIndex", 1)
          let routeData2 = this.$router.resolve({
            name: "BigScreenExam",
          });
          window.open(routeData2.href, '_blank');
          break;
        case 8:
          console.log("分析报告");
          this.$router.push({ name: 'ReportStageList', query: { pro_id: window.localStorage.getItem('proID') } });
          break;

        default:
          break;
      }
    },
    async handleZhuanKao() {
      const res = await examinationApi.getZhuanKaoExamQues({
        pro_id: window.localStorage.getItem("proID"),
        load: true,
        isShowErr: true
      });
      global.clearExamStorage();
      window.sessionStorage.setItem("isCanJumpExam", "true");
      window.localStorage.setItem("exam_ques", JSON.stringify(res.data))
      window.localStorage.setItem("exam_id", res.data.exam_id)
      this.$router.replace({ name: "TYKSPage",query:{
        examType:global.ExamType.ZhuanKao
      } });
    },
    handleCuoTiChaKan() {
      this.$router.replace({ name: "WrongCheck" });
    },
    async handleCuoTiZhuanKao(data) {
      data.form.set_start_time = global.formatTime(data.form.set_start_time);
      data.form.set_end_time = global.formatTime(data.form.set_end_time);

      const res = await wrongCheckApi.getCuoTiZhuanKaoExamQues({
        pro_id: window.localStorage.getItem("proID"),
        ...data.form,
        load: true,
        isShowErr: true
      });

      this.isShowCuotizhuankaoPop = false;

      res.data.ques.forEach(item => {
        item.ques_type = item.question_type;
        item.id = item.ques_id;
        return item;
      });

      global.clearExamStorage();
      window.sessionStorage.setItem("isCanJumpExam", "true");
      window.localStorage.setItem("exam_ques", JSON.stringify(res.data))
      window.localStorage.setItem("exam_id", res.data.errors_id)
      window.sessionStorage.setItem("wrongExam", JSON.stringify({errors_id:res.data.errors_id,ques_num:res.data.ques_num, ...data}));
      this.$router.replace({ name: "TYKSPage",query:{
        examType:global.ExamType.CuoTi
      } });
    }
  },
};
</script>
<style scoped>
/* ========== 页面背景 ========== */
.page_bg {
  background: linear-gradient(160deg, #f0f2ff 0%, #f7f8fc 40%, #f5f7fa 100%);
  padding-bottom: 20px;
}

/* ========== 顶部导航栏 ========== */
.back_box {
  width: 100%;
  max-width: 1160px;
  height: 56px;
  background: #fff;
  margin: 20px auto 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.back_left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.back_btn {
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #f0f2ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #646eff;
  font-weight: 500;
  transition: all 0.2s;
}

.back_btn:hover {
  background: #e4e7ff;
}

.back_btn i {
  font-size: 13px;
}

.page_title {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.class_name {
  color: #646eff;
  font-weight: 600;
}

/* ========== 主体布局 ========== */
.main_box {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* ========== 左侧功能入口 ========== */
.main_box .left {
  width: 796px;
  display: flex;
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 8px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(100, 110, 255, 0.07), 0 1px 4px rgba(0, 0, 0, 0.04);
  flex-wrap: wrap;
  justify-content: space-between;
}

.exam_item {
  width: 244px;
  height: 136px;
  position: relative;
  margin-bottom: 16px;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  animation: cardFadeIn 0.4s ease both;
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.exam_item.invisible {
  visibility: hidden;
}

.exam_item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.exam_item img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  transition: transform 0.4s;
}

.exam_item:hover img {
  transform: translate(-50%, -50%) scale(1.05);
}

.exam_item .text {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  position: absolute;
  left: 20px;
  top: 28px;
  z-index: 2;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.35), 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  letter-spacing: 1px;
}

.exam_item:hover .text {
  transform: translateX(4px);
}

/* 浅色背景卡片：用深色文字 + 白色描边保证可读性 */
.main_box .left .exam_item:nth-of-type(3) .text {
  color: #fff;
  text-shadow: 0 2px 8px rgba(80, 60, 160, 0.5), 0 0 20px rgba(100, 80, 200, 0.3);
}

.main_box .left .exam_item:nth-of-type(4) .text {
  color: #d4622a;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8), 0 2px 6px rgba(200, 100, 40, 0.2);
}

.main_box .left .exam_item:nth-of-type(5) .text {
  color: #d44a6a;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8), 0 2px 6px rgba(200, 70, 100, 0.2);
}

.main_box .left .exam_item:nth-of-type(6) .text {
  color: #2a8a5a;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8), 0 2px 6px rgba(40, 140, 90, 0.2);
}

.main_box .left .exam_item:nth-of-type(7) .text {
  color: #c47a20;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8), 0 2px 6px rgba(200, 120, 30, 0.2);
}

.main_box .left .exam_item:nth-of-type(8) .text {
  color: #fff;
  text-shadow: 0 2px 8px rgba(30, 120, 60, 0.5), 0 0 20px rgba(40, 160, 80, 0.3);
}

.main_box .left .exam_item:nth-of-type(9) .text {
  color: #fff;
  text-shadow: 0 2px 8px rgba(60, 60, 160, 0.5), 0 0 20px rgba(80, 80, 200, 0.3);
}

/* ========== 右侧考试成绩 ========== */
.main_box .right {
  margin-left: 15px;
  width: 333px;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(100, 110, 255, 0.07), 0 1px 4px rgba(0, 0, 0, 0.04);
}

.right_title {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1.5px solid #f0f1f5;
  font-size: 17px;
  font-weight: 700;
  color: #1e2330;
}

.title_icon {
  color: #646eff;
  font-size: 20px;
}

.btn_box {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  padding: 40px 30px 0;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}

.btn_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 12px 16px;
  border-radius: 14px;
}

.btn_item:hover {
  transform: translateY(-4px);
}

.btn_item img {
  width: 88px;
  height: 88px;
  transition: all 0.3s;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.08));
}

.btn_item:hover img {
  transform: scale(1.08);
  filter: drop-shadow(0 4px 12px rgba(100, 110, 255, 0.2));
}

.btn_item .text {
  font-weight: 700;
  font-size: 15px;
  color: #1e2330;
  margin-top: 10px;
}
</style>
